module.exports = __webpack_public_path__ + "static/media/dash-0.cbca793f.svg";